module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">Are you sure to delete this extra event?</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n\n  <p>Delete this extra event: <b>{{ $ctrl.extraEvent.title }}</b></p>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">OK</button>\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/adminExtraEvents/adminExtraEventDelete.html
// module id = 197
// module chunks = 0